export default __webpack_public_path__ + "imgs/kefu.539d0ddf.jpg";